import {combineReducers, configureStore} from '@reduxjs/toolkit'
import { CompaniesListReducer } from "./reducers/CompaniesListReducer";
import { UsersReducer } from "./reducers/UsersReducer";
import { UsersListReducer } from "./reducers/UsersListReducer";
import {persistReducer, persistStore} from "redux-persist";
import storage from 'redux-persist/lib/storage';
import {MonitoringListReducer} from "./reducers/MonitoringListReducer";
import {BranchesListReducer} from "./reducers/BranchReducer";
import {RolesReducer} from "./reducers/RolesReducer";
import {NotificationsReducer} from "./reducers/NotificationsReducer";
import {StatusesListReducer} from "./reducers/StatusesListReducer";
import {WebRTCReducer} from "./reducers/WebRTCReducer";
import {QueueListReducer} from "./reducers/QueueReducer";
import {QualificationGroupListReducer} from "./reducers/QualificationGroupReducer";
import {TrunksListReducer} from "./reducers/TrunksReducer";
import {AudioListReducer} from "./reducers/AudioReducer";
import {AudioControlListReducer} from "./reducers/AudioControlReducer";
import {IVRConfigurationReducer} from "./reducers/IVRConfigurationReducer";
import {StatisticsListReducer} from "./reducers/StatisticsListReducer";
import {QualityControlStatisticsReducer} from "./reducers/QualityControlStatisticsReducer";
import {StatisticsCallsListReducer} from "./reducers/CallsStatisticsListReducer";
import {StatisticsStatusListReducer} from "./reducers/StatusStatisticsListReducer";
import {TrunkStatisticsListReducer} from "./reducers/TrunkStatisticsListReducer";
import {StatusesByPeriodListReducer} from "./reducers/StatusesByPeriodListReducer";
import {ThemeReducer} from "./reducers/ThemeReducer";
import {TwoFactorReducer} from "./reducers/TwoFactorReducer";

const usersPersistConfig = {
    key: 'callcenter:user',
    storage
}

const rolesPersistConfig = {
    key: 'callcenter:role_vision',
    storage,
    whitelist: ['rolesVision', 'userSortFields', 'userStatisticSortFields', 'userQualityControlSortFields']
}

const themePersistConfig = {
    key: 'callcenter:theme',
    storage,
    whitelist: ['theme', 'colorScheme', 'componentTheme']
}

const rootReducer = combineReducers({
    CompaniesListReducer: CompaniesListReducer,
    UsersListReducer: UsersListReducer,
    BranchesListReducer: BranchesListReducer,
    MonitoringListReducer: MonitoringListReducer,
    NotificationsReducer: NotificationsReducer,
    StatusesListReducer: StatusesListReducer,
    StatusesByPeriodListReducer: StatusesByPeriodListReducer,
    QualificationGroupListReducer: QualificationGroupListReducer,
    WebRTCReducer: WebRTCReducer,
    QueueListReducer: QueueListReducer,
    AudioListReducer: AudioListReducer,
    TrunksListReducer: TrunksListReducer,
    AudioControlListReducer: AudioControlListReducer,
    IVRConfigurationReducer: IVRConfigurationReducer,
    StatisticsListReducer: StatisticsListReducer,
    QualityControlStatisticsReducer: QualityControlStatisticsReducer,
    StatisticsCallsListReducer: StatisticsCallsListReducer,
    StatisticsStatusListReducer: StatisticsStatusListReducer,
    TrunkStatisticsListReducer: TrunkStatisticsListReducer,
    TwoFactorReducer: TwoFactorReducer,
    UsersReducer: persistReducer(usersPersistConfig, UsersReducer),
    RolesReducer: persistReducer(rolesPersistConfig, RolesReducer),
    ThemeReducer: persistReducer(themePersistConfig, ThemeReducer)
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }),
})

export default store;
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
